import { BlockType } from '@uno/common-cms';
import { getIsBlockSelected } from '../util/block';

var findSelectedTextBlocks = function findSelectedTextBlocks(contentBlock, callback) {
  if (contentBlock.getType() === BlockType.ATOMIC || contentBlock.getType() === BlockType.TABLE) {
    return;
  }

  var isBlockSelected = getIsBlockSelected(contentBlock);

  if (!isBlockSelected) {
    return;
  }

  var length = contentBlock.getLength();
  callback(0, length);
};

export default findSelectedTextBlocks;